<template>
  <div style="margin: 0;background-color: white;position: relative">
    <div style="background-color: white;height: 230px;display: flex;justify-content: center;justify-items: center">
      <el-image :src="require('@/assets/img/down_logo.png')"
                style="width: 100px; height: 150px;margin-top: 50px"
                fit="fill"></el-image>
    </div>
    <div>
      <img src="@/assets/img/背景.png" style="width: 100%">
      <div
          style="font-size: 30px;color: white;margin-top: 20px;position:absolute;top: 50vh;width: 100%;text-align: center;">
        爱生活·爱同正
      </div>
      <div
          style="font-size: 12px;color: white;margin-top: 20px;position:absolute;top: 58vh;width: 100%;text-align: center;">
        ——————&nbsp;&nbsp;&nbsp;移动互联网金融平台&nbsp;&nbsp;&nbsp;——————
      </div>
    </div>
    <div style="margin-top: 10px;position:absolute;top: 70vh;width: 100%;text-align: center;">
<!--      <el-button type="primary" round class="button" @click="onBtnClick(1)"><i class="el-icon-my-export"></i>-->
<!--        Android版下载-->
<!--      </el-button>-->
<!--      <el-button type="primary" round class="button" @click="onBtnClick(2)"><i class="el-icon-my-export-ios"></i>-->
<!--        iPhone版下载-->
<!--      </el-button>-->

      <div class="button" @click="onBtnClick(1)">
        <img class="icon" src="~@/assets/img/android.png" alt="">
        <span style="margin-left: 10px;">Android版下载</span>
      </div>
      <div class="button"  @click="onBtnClick(2)">
        <img class="icon" src="~@/assets/img/苹果.png" alt="">
        <span style="margin-left: 10px"> iPhone版下载&nbsp;&nbsp;</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "index",
  created() {
    this.getLinkFromDevice();
    this.appmanagement()
  },
  data() {
    return {
      url: '',
    }
  },
  methods: {
    onBtnClick(val) {
      if (val === 1) {//安卓
        if (this.url === '') {
          return alert('下载连接错误')
        }
        window.open(this.url)
      } else {//苹果
        alert("敬请期待")
      }
    },
    // 获取安卓下载地址
    appmanagement() {
      this.$request({
        url: '/api/android/appmanagement/id',
        method: 'post',
        data: {
          id: '448889548989460480'// 正式环境:448889548989460480 测试环境：459391713676599296
        }
      }).then(res => {
        this.url = res.data.downloadPackage
      })
    },
    //区分手机和PC
    getLinkFromDevice() {
      if (this._isMobile()) {
        this.$router.replace({path: 'm_appDown'});
      } else {
        this.$router.replace({path: 'appDown'});
      }
    },
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    }
  },
}
</script>

<style scoped>
.button {
  color: #FF3D32;
  text-align: center;
  background-color: white;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 300px;
  height: 40px;
  padding: 10px 0;
  line-height: 40px;
  border: 1px solid #FF3D32;
  border-radius: 5px;
  margin: 10px auto
}

.el-icon-my-export {
  background: url('~@/assets/img/android.png') center no-repeat;
  background-size: cover;
}
.icon {
  height: 25px;
  width: 25px;
  display: inline-block;
  vertical-align: middle;
}
.el-icon-my-export:before {
  content: "替";
  font-size: 25px;
  visibility: hidden;
}

.el-icon-my-export-ios {
  background: url('~@/assets/img/苹果.png') no-repeat;
  background-size: cover;
}

.el-icon-my-export-ios:before {
  content: "替";
  font-size: 25px;
  visibility: hidden;
}
</style>
